import { LifeBuoy } from 'lucide-react'
import * as React from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { SupportTicketDialog } from '@/modules/support/SupportTicketDialog'

/** Ajuda no topo: abre o chamado para o time de Sistemas (funil do Hub). */
export function SupportButton() {
  const [open, setOpen] = React.useState(false)
  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label="Abrir um chamado sobre o sistema"
            aria-haspopup="dialog"
            onClick={() => setOpen(true)}
          >
            <LifeBuoy />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Ajuda · abrir chamado</TooltipContent>
      </Tooltip>
      <SupportTicketDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
